import { API, post } from 'utils/api';
import { createReducer } from 'utils/redux';
import { CollabaryVideoUploadResponse } from 'utils/collabary-video-upload';
import {
  subscribe
} from 'utils/server-sent-events';

import type {
  CloudinaryVideoState
} from 'redux-store/types/CloudinaryVideosReducer.type';
import type { CampaignAsset, DeliverableAttachment, Dispatch } from 'types';

const SET_CLOUDINARY_URL = 'cloudinaryVideos/SET_CLOUDINARY_URL';

const publicIdToS3UrlMap:{ [key: string]: [string, Dispatch] } = {};

const initialState: CloudinaryVideoState = {
  videoMapping: {}
};

function setCloudinaryUrlMapping(s3Url: string, cloudinaryUrl: string, publicId: string) {
  return {
    type: SET_CLOUDINARY_URL,
    payload: {
      s3Url,
      cloudinaryUrl,
      publicId
    }
  };
}

export function initSubscription() {
  subscribe('cloudinary_upload_finished', data => {
    const entity = publicIdToS3UrlMap[data.publicId];

    if (entity) {
      delete publicIdToS3UrlMap[data.publicId];
    }

    const [s3Url, dispatch] = entity;

    dispatch(setCloudinaryUrlMapping(s3Url, data.cloudinaryUrl, data.publicId));
  });
}


export function initCloudinaryStreaming(entries: Array<DeliverableAttachment | CampaignAsset>) {
  const startCloudinaryStreamingUrl = API.END_POINTS.API.STREAM_CLOUDINARY;

  return async (dispatch) => {
    Promise.all(
      entries
        .reduce<Array<CollabaryVideoUploadResponse>>((result, attachment) => {
          if (attachment?.meta && 'videoUploadResponse' in attachment.meta) {
            return [...result, attachment.meta.videoUploadResponse];
          }

          return result;
        }, [])
        .map(async (meta) => {
          const response = await post(startCloudinaryStreamingUrl, { data: meta });

          publicIdToS3UrlMap[response.data.publicId] = [meta.data.url, dispatch];
        })
    );
  };
}

export default createReducer<CloudinaryVideoState, any>('cloudinaryVideos', initialState, {
  [SET_CLOUDINARY_URL]: (state, { s3Url, cloudinaryUrl, publicId }) => ({
    ...state,
    videoMapping: {
      ...state.videoMapping,
      [s3Url]: { cloudinaryUrl, publicId }
    }
  })
});
